import { t } from '@trimble/i18n';
import { Component, mergeProps, onMount } from 'solid-js';

export interface ConfirmModusHandle {
  show(): void;
  close(): void;
  getDialog(): HTMLDialogElement | null;
}

interface IConfirmModus {
  id?: string;
  header?: string;
  description?: string;
  showClose?: boolean;
  primaryButtonLabel?: string;
  primaryButtonClass?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'warning'
    | 'danger';
  secondaryButtonLabel?: string;
  secondaryButtonClass?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'warning'
    | 'danger';
  onCancel(): void;
  onConfirm(): void;
  modalRef(handle: ConfirmModusHandle): void;
}

export const ConfirmModus: Component<IConfirmModus> = (p: IConfirmModus) => {
  const props = mergeProps(
    {
      id: 'confirm-modus-modal',
      primaryButtonLabel: t('general.yes'),
      secondaryButtonLabel: t('general.no'),
      showClose: true,
    },
    p
  );

  let modalEl: HTMLDialogElement | null;
  let initialized: boolean = false;

  //this must run after the component is hydrated
  const getDialog = (): HTMLDialogElement | null => {
    if (!initialized) {
      const modalWrapper = document.getElementById(
        `${props.id}-dialog`
      ) as HTMLDialogElement;
      const dialogElement = modalWrapper?.querySelector('dialog');
      modalEl = dialogElement;
      initialized = dialogElement !== null;
    }
    return modalEl;
  };

  onMount(() => {
    props.modalRef({
      show: () => {
        if (!initialized) getDialog();
        modalEl?.showModal?.();
      },
      close: () => {
        if (!initialized) getDialog();
        modalEl?.close?.();
      },
      getDialog,
    });
  });

  return (
    <>
      <modus-wc-modal
        aria-label="confirm-modal"
        custom-class=""
        fullscreen={false}
        id={props.id ? `${props.id}-dialog` : 'confirm-modus-modal'}
        modal-id={props.id ?? 'confirm-modus-modal'}
        backdrop="default"
        position="center"
        show-close={props.showClose}
        show-fullscreen-toggle="false"
      >
        <span slot="header">{props.header}</span>
        <span slot="content">{props.description}</span>
        <modus-wc-button
          slot="footer"
          id="close-modal-btn-primary"
          size="md"
          variant="filled"
          color={props.primaryButtonClass ?? 'primary'}
          onClick={() => {
            props.onConfirm();
            modalEl?.close();
          }}
        >
          {props.primaryButtonLabel}
        </modus-wc-button>
        <modus-wc-button
          slot="footer"
          id="close-modal-btn-secondary"
          size="md"
          variant="filled"
          color={props.secondaryButtonClass ?? 'secondary'}
          onClick={() => {
            props.onCancel();
            modalEl?.close();
          }}
        >
          {props.secondaryButtonLabel}
        </modus-wc-button>
      </modus-wc-modal>
    </>
  );
};
